import Vue from 'vue'
import Router from 'vue-router'
import hello from '@/view/hello'
Vue.use(Router)
//配置路由重复跳转
const original = Router.prototype.push
Router.prototype.push = function push(location) {
  return original.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'hash',
  routes: [{
      path: '',
      name: '',
      component: () => import('@/view/ziuxn')
    },
    {
      path: '/',
      name: '',
      component: () => import('@/view/ziuxn')
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/view/ziuxn')
    },
    {
      path: '/ziuxn',
      name: 'ziuxn',
      component: () => import('@/view/ziuxn')
    },
    {
      path: '/zhuanti/:id',
      name: 'zhuanti',
      component: () => import('@/view/zhuanti')
    },
    {
      path: '/langVideo',
      name: 'langVideo',
      component: () => import('@/view/langVideo')
    },
    {
      path: '/shortVideo',
      name: 'shortVideo',
      component: () => import('@/view/shortVideo')
    },
    {
      path: '/normalDetail/:id',
      name: 'normalDetail',
      component: () => import('@/view/normalDetail')
    },
    {
      path: '/noticeDetail',
      name: 'noticeDetail',
      component: () => import('@/view/noticeDetail')
    },
    {
      path: '/downPage',
      name: 'downPage',
      component: () => import('@/view/downPage')
    },
    {
      path: '/downCenter',
      name: 'downCenter',
      component: () => import('@/view/downCenter')
    },
    {
      path: '/searchPage',
      name: 'searchPage',
      component: () => import('@/view/searchPage')
    },
    {
      path: '/collectPage',
      name: 'collectPage',
      component: () => import('@/view/collectPage')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/view/about')
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js